import { h, Component } from 'preact'
import style from './styles/app.scss'

import ChatContainer from '../containers/ChatContainer'

const App = () => (
  <div class={style.normal}>
    <ChatContainer />
  </div>
)

export default App



// WEBPACK FOOTER //
// ./components/App.js